export default __webpack_public_path__ + "static/bratz-game-desktop-13ea3c4f87ecb857fab57c9b922c05ee.webp";